import React from "react"
import { Popover, Flex, Tooltip, Checkbox } from "antd"
import { uniq } from "lodash"

// @ts-ignore
import useGlobalFilterStore from "context/stores/useGlobalFilterStore"

// @ts-ignore
import { useGetGlobalFilter, usePostGlobalFilter } from "api/hooks/global"
// @ts-ignore
import Label from "components/Label/Label"
// @ts-ignore
import { PrimeButton } from "components-design-system"

// styles
import "./GlobalFilter.scss"

// types
const options = [
  {
    value: 1,
    label: (
      <Tooltip
        placement="top"
        title="Shows records where you are directly involved"
      >
        My Records
      </Tooltip>
    ),
  },
  {
    value: 2,
    label: (
      <Tooltip
        placement="top"
        title="Shows records you've marked as favorites"
      >
        Favorite Records
      </Tooltip>
    ),
  },
  {
    value: 3,
    label: (
      <Tooltip
        placement="top"
        title="Shows all available records"
      >
        All Records
      </Tooltip>
    ),
  },
]

interface FilterMap {
  studies: string[]
  requests: string[]
}

export default function GlobalFilter() {
  const [selectedFilters, setSelectedFilters] = React.useState<number[]>([])
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const { data: globalFilter } = useGetGlobalFilter()
  const postGlobalFilter = usePostGlobalFilter()
  const { setMyFilteredRecordsMap, setIsFilterOn, isFilterOn } = useGlobalFilterStore()

  React.useEffect(() => {
    const updateFilteredMap = ({ studies, requests, map }: { studies: string[]; requests: []; map: FilterMap }) => {
      if (studies) {
        studies.forEach((studyId: string) => {
          map.studies.push(studyId)
        })
      }

      if (requests) {
        requests.forEach((requestId: any) => {
          map.requests.push(requestId)
        })
      }

      return map
    }

    if (globalFilter) {
      const selectedFilters: number[] = []
      let map: FilterMap = {
        studies: [],
        requests: [],
      }

      if (globalFilter?.my_filter?.enable) {
        selectedFilters.push(1)
        map = updateFilteredMap({
          studies: globalFilter.my_filter.filter_study_ids,
          requests: globalFilter.my_filter.filter_request_ids,
          map,
        })
      }
      if (globalFilter?.fav_filter?.enable) {
        selectedFilters.push(2)
        map = updateFilteredMap({
          studies: globalFilter.fav_filter.filter_study_ids,
          requests: globalFilter.fav_filter.filter_request_ids,
          map,
        })
      }
      if (globalFilter?.my_filter?.enable === false && globalFilter?.fav_filter?.enable === false) {
        selectedFilters.push(3)
      }

      map.studies = uniq(map.studies)
      map.requests = uniq(map.requests)

      setMyFilteredRecordsMap({
        studies: new Set(map.studies),
        requests: new Set(map.requests),
      })

      setSelectedFilters(selectedFilters)
    }
  }, [globalFilter])

  const onSave = () => {
    if (postGlobalFilter) {
      setIsLoading(true)
      const isMyFilterEnabled = selectedFilters.find((item) => item === 1) ? true : false
      const isFavFilterEnabled = selectedFilters.find((item) => item === 2) ? true : false

      postGlobalFilter(
        {
          body: {
            my_filter: { enable: isMyFilterEnabled },
            fav_filter: { enable: isFavFilterEnabled },
          },
        },
        {
          onSuccess: () => window.location.reload(),
          onSettled: () => {
            setIsLoading(false)
          },
        }
      )
    }
  }

  React.useEffect(() => {
    const hasFilter = globalFilter?.my_filter?.enable || globalFilter?.fav_filter?.enable
    setIsFilterOn(hasFilter)
  }, [JSON.stringify(globalFilter)])

  // jsx
  return (
    <div className={`global-filter-container ${isFilterOn ? "has-badge" : ""}`}>
      <Popover
        trigger="click"
        placement="bottomRight"
        content={
          <Flex
            vertical={true}
            gap={4}
          >
            <Label>Global Filter</Label>
            <Checkbox.Group
              // @ts-ignore
              value={selectedFilters}
              defaultValue={["Apple"]}
              onChange={(value: any) => {
                let values = value

                if (value.length === 0) {
                  setSelectedFilters([3])
                } else if (value.length > 0 && value[value.length - 1] === 3) {
                  setSelectedFilters([3])
                } else {
                  const findIndex = values.findIndex((item: any) => item === 3)
                  if (findIndex !== -1 && values.length > 1) {
                    values.splice(findIndex, 1)
                  }
                  setSelectedFilters(values)
                }
              }}
            >
              <Flex vertical={true}>
                {options.map((item) => {
                  return (
                    <Checkbox
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Checkbox>
                  )
                })}
              </Flex>
            </Checkbox.Group>
            <PrimeButton
              loading={isLoading}
              style={{ marginTop: 10 }}
              onClick={onSave}
            >
              Save Filter
            </PrimeButton>
          </Flex>
        }
      >
        <i
          className="fa-light fa-sliders global-filter-icon"
          role="button"
          aria-haspopup="true"
        />
      </Popover>
    </div>
  )
}
